import {type Components} from "@mui/material/styles";
import type {Theme} from "../..";

type MuiButtonBaseOverrides = Components<Theme>["MuiButtonBase"];

const overrides: MuiButtonBaseOverrides = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: ({theme}) => ({
            "&::before": {
                content: "''",
                position: "absolute",
                width: "calc(100% + 8px)",
                height: "calc(100% + 8px)",
                border: `1.5px solid transparent`,
                borderRadius: "inherit",
            },

            "&:focus-visible": {
                "&::before": {
                    border: `1.5px solid ${theme.color.border.focused}`,
                    outline: `1.5px solid ${theme.color.border.inverted.strong}`,
                    outlineOffset: -3,
                },
            },
        }),
    },
};

export default overrides;
